document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', () => {
  if (window.matchMedia('(max-width: 749px)').matches) {
    document.querySelectorAll('.footer-menu').forEach((menu) => menu.removeAttribute('open'));
  }

  document.querySelectorAll('[data-mobile-drawer]').forEach((drawer) => {
    drawer.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') drawer.removeAttribute('open');
    });

    drawer.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => drawer.removeAttribute('open'));
    });
  });

  document.querySelectorAll('[data-comparison]').forEach((comparison) => {
    const tabs = Array.from(comparison.querySelectorAll('[data-comparison-tab]'));
    const panels = Array.from(comparison.querySelectorAll('[data-comparison-panel]'));

    const activateTab = (tab) => {
      const target = tab.dataset.comparisonTab;
      tabs.forEach((item) => {
        const active = item === tab;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach((panel) => {
        panel.hidden = panel.dataset.comparisonPanel !== target;
      });
    };

    tabs.forEach((tab) => tab.addEventListener('click', () => activateTab(tab)));
    if (tabs[0]) activateTab(tabs[0]);
  });

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const variantSelect = root.querySelector('[data-variant-select]');
    const price = root.querySelector('[data-product-price]');
    const stickyPrice = root.querySelector('[data-sticky-price]');
    const addButtons = root.querySelectorAll('[data-add-to-cart]');

    const updateVariant = () => {
      if (!variantSelect) return;
      const option = variantSelect.options[variantSelect.selectedIndex];
      const available = option.dataset.available === 'true';
      const formattedPrice = option.dataset.price;

      if (price && formattedPrice) price.textContent = formattedPrice;
      if (stickyPrice && formattedPrice) stickyPrice.textContent = formattedPrice;
      addButtons.forEach((button) => {
        button.disabled = !available;
        button.textContent = available ? button.dataset.availableLabel : button.dataset.soldOutLabel;
      });
    };

    if (variantSelect) {
      variantSelect.addEventListener('change', updateVariant);
      updateVariant();
    }

    root.querySelectorAll('[data-media-thumbnail]').forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        const mediaId = thumbnail.dataset.mediaThumbnail;
        root.querySelectorAll('[data-product-media]').forEach((media) => {
          media.hidden = media.dataset.productMedia !== mediaId;
        });
        root.querySelectorAll('[data-media-thumbnail]').forEach((item) => {
          item.classList.toggle('is-active', item === thumbnail);
        });
      });
    });
  });
});
